import React from 'react';
import emblemSrc from '../assets/idfc_emblem.png';
import fullLogoSrc from '../assets/idfc_logo.jpg';

// Official IDFC rainbow-swoosh emblem on a brand-navy tile
export const LogoIcon = ({ size = 40, className = '' }) => (
  <div
    className={`brand-tile rounded-xl flex items-center justify-center shrink-0 ${className}`}
    style={{ width: size, height: size }}
    data-testid="idfc-logo"
  >
    <img
      src={emblemSrc}
      alt="IDFC"
      className="object-contain"
      style={{ width: size * 0.66, height: size * 0.66 }}
    />
  </div>
);

// Full official lockup (wordmark + emblem) for hero/auth screens
export const LogoFull = ({ className = '', style = {} }) => (
  <img
    src={fullLogoSrc}
    alt="International Development Finance Club"
    className={`object-contain rounded-2xl ${className}`}
    style={style}
    data-testid="idfc-logo-full"
  />
);

export const LogoBrand = ({ size = 40, showText = true, textSize = 'lg' }) => (
  <div className="flex items-center gap-3">
    <LogoIcon size={size} />
    {showText && (
      <div className="leading-none">
        <h1
          className={`font-heading text-${textSize} font-bold tracking-tight lowercase`}
          style={{ color: 'var(--idfc-text-primary, #FFF)' }}
        >
          idfc
        </h1>
        <p
          className="text-[10px] tracking-[0.18em] uppercase mt-0.5"
          style={{ color: 'var(--idfc-text-muted, #94A3B8)' }}
        >
          Co-Financing Platform
        </p>
      </div>
    )}
  </div>
);

export default LogoIcon;
